/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Age_With_DateInputs */

const en_dashboard_age_with_date = /** @type {(inputs: Dashboard_Age_With_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quarterly distribution`)
};

const pt_br2_dashboard_age_with_date = /** @type {(inputs: Dashboard_Age_With_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distribuição trimestral`)
};

/**
* | output |
* | --- |
* | "Quarterly distribution" |
*
* @param {Dashboard_Age_With_DateInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dashboard_age_with_date = /** @type {((inputs?: Dashboard_Age_With_DateInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Age_With_DateInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_age_with_date(inputs)
	return pt_br2_dashboard_age_with_date(inputs)
});